import * as React from "react";

export const Ratio11Svg = ({}) => (
    <svg viewBox="0 0 100 100">
        <rect x={0} y={0} width={100} height={100} stroke="none" fill="currentColor"/>
    </svg>
);

